import api from './client';

export interface MindMapNode {
  id: string;
  data: { label: string };
  position: { x: number; y: number };
  style?: { backgroundColor?: string; border?: string };
}

export interface MindMapEdge {
  id: string;
  source: string;
  target: string;
  animated?: boolean;
  style?: { stroke?: string; strokeWidth?: number };
}

export interface MindMap {
  _id: string;
  name: string;
  description?: string;
  nodes: MindMapNode[];
  edges: MindMapEdge[];
  createdAt: string;
  updatedAt: string;
}

export const getMindMaps = () => api.get('/mindmaps');
export const getMindMap = (id: string) => api.get(`/mindmaps/${id}`);
export const createMindMap = (data: any) => api.post('/mindmaps', data);
export const updateMindMap = (id: string, data: any) => api.put(`/mindmaps/${id}`, data);
export const deleteMindMap = (id: string) => api.delete(`/mindmaps/${id}`);